import type { ReactNode } from 'react';
import { HalftonePanel } from './HalftonePanel';
import { APP_NAME, APP_VERSION, BRAND_BACKDROP, BRAND_LOGO, BRAND_NAME } from '../lib/brand';

interface Props {
  children: ReactNode;
  /** Drawn over the whole page — the verification-code dialog. */
  overlay?: ReactNode;
}

/**
 * The frame every signed-out page shares: backdrop, wordmark, logo and footer.
 * Sign-in and Forgot password put their own card inside it.
 */
export function SignInShell({ children, overlay }: Props) {
  return (
    <div className="signin">
      {/* Supplied artwork if there is any, otherwise an equivalent drawn one. */}
      {BRAND_BACKDROP ? (
        <div
          className="halftone halftone--img"
          style={{ backgroundImage: `url(${BRAND_BACKDROP})` }}
          aria-hidden="true"
        />
      ) : (
        <HalftonePanel />
      )}

      <div className="signin-inner">
        <header className="signin-head">
          <div>
            <h1 className="wordmark">{BRAND_NAME}</h1>
            <p className="tagline">Integrated Well Operations Portal</p>
          </div>

          {BRAND_LOGO ? (
            <img className="signin-logo" src={BRAND_LOGO} alt={BRAND_NAME} />
          ) : (
            <span className="signin-logo signin-logo--placeholder" aria-hidden="true">
              <svg viewBox="0 0 32 32" width="26" height="26">
                <path
                  d="M16 2.5c5.2 6 9 10.6 9 15.2A9 9 0 0 1 7 17.7c0-4.6 3.8-9.2 9-15.2Z"
                  fill="var(--brand)"
                />
                <path
                  d="M16 8.6c2.9 3.5 4.8 6 4.8 8.6a4.8 4.8 0 0 1-9.6 0c0-2.6 1.9-5.1 4.8-8.6Z"
                  fill="#fff"
                  opacity=".85"
                />
              </svg>
              <b>{BRAND_NAME}</b>
            </span>
          )}
        </header>

        {children}
      </div>

      <footer className="signin-foot">
        v{APP_VERSION} | Copyright © {new Date().getFullYear()} {APP_NAME}
      </footer>

      {overlay}
    </div>
  );
}
